export default __webpack_public_path__ + "static/media/undraw_product_tour_foyt.9ac356b8.svg";